// @flow

import geoipData from '../geoIPMockData.json';
import type { wrappedApiResponseType } from '../../apiTypes';
import type { geoipType } from '../../../types';

export const geoipMock = {
  getLocationFromIp: (): Promise<{ lat: number, lng: number }> => {
    console.log('geoipMock.getLocationFromIp');
    return Promise.resolve({
      lat: geoipData.latitude,
      lng: geoipData.longitude,
    });
  },

  getLocationFromIpFull: (): Promise<wrappedApiResponseType<geoipType>> => {
    console.log('geoipMock.getLocationFromIpFull');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: geoipData,
    });
  },

  getLocationFromNavigator: () =>
    new Promise<{ lat: number, lng: number }>((resolve, reject) => {
      if (geoipData.latitude && geoipData.longitude) {
        resolve({
          lat: geoipData.latitude,
          lng: geoipData.longitude,
        });
      } else {
        reject(new Error('Navigator location not available in mock'));
      }
    }),

  getLocation: () => {
    return geoipMock
      .getLocationFromIp()
      .catch(() => geoipMock.getLocationFromNavigator())
      .catch(() => null);
  },
};
